module.exports = __webpack_public_path__ + "static/media/top-img_10_mob.9740d03b.png";